import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .sluggable()
    .hasTitle()
	.hasLede()
	.hasSummary()
	.hasImage()
    .hasBody()
    .hasMetadata()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

schema.prop('useMinimalFooter').setType(Boolean).setValue(false).addMetadata('mergeable', true).addMetadata('draftable', true);

export default schema;
